import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import PageHeader from '../components/PageHeader';

export default function Goals() {
  return (
    <Box>
      <PageHeader
        title="Goals"
        subtitle="Create member targets and track goal progress once this module is enabled."
        gradient="linear-gradient(90deg, #059669, #34D399)"
        actions={<Button variant="contained" size="small" startIcon={<Add />} disabled>Create Goal</Button>}
      />

      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="body2" color="text.secondary">
          Goal management is coming soon.
        </Typography>
      </Box>
    </Box>
  );
}
